import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-100 min-h-screen" }
const _hoisted_2 = { class: "p-4 text-sm text-center" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "pt-32 text-center text-primary-dark font-bold" }, [
      _createElementVNode("p", { class: "mb-10 text-3xl" }, "認証エラーが発生しました")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (!!_ctx.errors && _ctx.errors.invalid_params)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errors.invalid_params[0].reason), 1))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createElementVNode("p", null, "お手数ですが、ログインからやり直ししてください。", -1))
    ])
  ]))
}